<div class="row">
  <div class="row__text">
    <div class="row__label-line">
      <span class="row__label">{{ label() }}</span>
      <ng-content select="[rowBadge]" />
    </div>
    @if (description()) {
      <p class="row__description">{{ description() }}</p>
    }
    <ng-content select="[rowDescription]" />
  </div>
  <div class="row__control">
    <ng-content />
  </div>
</div>
